'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_1kh9l_1";
const styles = {
	root: root
};

const BlockGrid = ({ children, maxColumns, maxWidth = 1170 }) => {
  const childrenLength = maxColumns || React.Children.toArray(children).length;
  return React__default.default.createElement("div", { className: styles.root, "data-zds": true, style: {
    "--_zds-block-grid-max-width": maxWidth,
    // BlockGrid requires 3 different grid layouts for different breakpoints.
    "--_zds-block-grid-grid-template-columns-small": "repeat(1, 1fr)",
    "--_zds-block-grid-grid-template-columns-medium": `repeat(${childrenLength === 2 || maxColumns === 2 ? 2 : 1}, 1fr)`,
    "--_zds-block-grid-grid-template-columns-large": `repeat(${childrenLength}, 1fr)`
  } }, children);
};

exports.BlockGrid = BlockGrid;
//# sourceMappingURL=BlockGrid.cjs.js.map
